import React,{ Fragment, useEffect, useState, useRef } from "react";
import { Form, Input, Select,Button } from "antd";
import belgeTuruLists from '../../services/belgeTuruLists';
import history from "../../history";
import queryString from 'query-string';
import basvuruAnaDurumTurleriList from "../../services/basvuruAnaDurumTurleriList";
import harcTurTanimList from "../../services/harcTurTanimLists";
const { Option } = Select;

const parsed = queryString.parse(history.location.search);


const HarcEkleSecimForm =(props) =>
{
    const [harcTurTanims, setHarcTurTanims] = useState([]);
 
    const [form] = Form.useForm();
    const belgeGrubuId = parsed.belgeGrubuId.split(',').map(item=> { return parseInt(item)});
    const basvuruId = parsed.basvuruId;
    
    useEffect(() => {
        harcTurTanimList().then(res=> {setHarcTurTanims(res.data.result)});
      }, []);

      const onFinish = (values) =>
      {
            props.onSubmit(values.harcTurTanimObjectIdRef,basvuruId);
      }

      return <Form layout="inline" style={{marginLeft : 10}}    onFinish={onFinish} >
      <Form.Item name="harcTurTanimObjectIdRef"
      rules={[{ required: false, message: 'Lütfen Harç Türü Seçiniz!' }]} >
      <Select
          showSearch
          allowClear
          filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
          placeholder="Harç Türü"
          style={{ width: 200 }}
          // onChange={onBelgeTuruChange}
          >
          {harcTurTanims && harcTurTanims.map(bt => <Option key={bt.id} value={bt.id}>{bt.adi}</Option>)}
      </Select>
  </Form.Item>
  <Form.Item>
        <Button type="primary" htmlType="submit" style={{ marginBottom: 20,marginLeft: 10 }} onClick={() => {
                
            }}>
                <span style={{ fontWeight: "bold" }}>Sorgula</span>
            </Button>
        </Form.Item>
 </Form>

}

export default HarcEkleSecimForm;